export default __webpack_public_path__ + "static/media/stack.a5b45410.png";